<template>
  <v-container fluid pa-0>
    <v-row align="center">
      <v-col cols="12" sm="8" md="6">
        <div v-if="title">
          <h1 class="title-style">{{ title }}</h1>
        </div>
      </v-col>
      <v-col cols="12" sm="4" md="3" offset-md="3" align="end">
        <slot name="right-buttons"></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: [
    'title'
  ]

}
</script>

<style>

</style>
